import Dialog, { Transition } from "./Dialog";

export default Dialog
export { Transition }
